export function isDecoratorKey(e: KeyboardEvent) {
    return e && (e.metaKey || e.shiftKey || e.ctrlKey);
}
